import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

import { ReceiptInvoice } from '@app/_models/home/invoices';

const baseUrl = `${environment.apiUrl}/api/invoice`;

@Injectable({ providedIn: 'root' })
export class ReceiptService {

  constructor(private httpClient: HttpClient) { }

  list(id: number): Observable<ReceiptInvoice[]> {
    return this.httpClient.get<any[]>(`${baseUrl}/list?id=${id}`);
  }
}
